import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import colors from '../../../configuration/colors'

const ButtonElement = styled.button`
  background: ${props => (props.disabled ? colors.rock : 'transparent')};
  color: ${props => (props.disabled ? colors.white : colors.charcoal4)};
  border: 1px solid ${colors.aluminum};
  height: 40px;
  width: ${props => props.width};
  line-height: 40px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 20px;
  &:before {
    content: none;
  }

  &:hover {
    color: ${colors.white};
    border: 1px solid ${colors.charcoal4};
    background: ${colors.charcoal4};
    box-shadow: none;
  }
`

export const CancelButton = ({
 handleClick,
 title,
 width
}) => {
  return (
    <ButtonElement width={width} onClick={handleClick}>
      {title}
    </ButtonElement>
  )
}

CancelButton.propTypes = {
  handleClick: PropTypes.func,
  title: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired
}

export default CancelButton



// WEBPACK FOOTER //
// ./src/components/mini/Buttons/CancelButton.js